import { useState, useEffect} from 'react';
import Doughnutchart from '../Doughnutchart';



function FetchAllAirportsDoughnutChart({ Time, MeasurementIndicator}) {
    
    const [userData, setUserData] = useState([]);

    const [excelDataChart,setexcelDataChart] = useState([]);

    
    useEffect(() => {
        
        //Url for getting Data for all airports
        var url = '/api/get_indicator_by_year/' +Time+"/"+ MeasurementIndicator ;

        fetch(url).then((res) =>
           res.json().then((res) => {

            console.log("Res doughnut", res)

            const keys = Object.keys(res.data.data);
            
            
            let listOfIds = []
            let listOfValues = []

            keys.forEach((airport, i) => {
                //Slice airport to get the same code ex instead of Airport Κρατικός Αερολιμένας Καρπάθου (AOK) get AOK to match the code passed
                const str = JSON.stringify(airport);
                const code2 = str.slice(-5,-2)


                // TODO: CHECK IF CODES ARE GOOD MIGHT BE A DIFFERENT SLICE
                

             
                listOfValues.push(res.data.data[airport])
                listOfIds.push(code2)
                

                
            });

            setUserData({
                labels: listOfIds,
                datasets: [{
                  label: "",
                  data: listOfValues,
                  backgroundColor: "#0F8DD6",
                  borderColor: "black",
                  borderWidth: 0.1,
                }]
              })
            
            
            let exceldata = []
            for (let i = 0; i < listOfIds.length; i++) {
                exceldata.push({"Αεροδρόμιο": listOfIds[i], [MeasurementIndicator]: listOfValues[i]})
            }
            
            setexcelDataChart(exceldata)



            console.log("Values", listOfValues)
            console.log("IDS", listOfIds)


           
          })
        )
        .catch((error) => {
          console.log("Refetching data for All Airports Dougnut Chart!")
        });
      }, [Time, MeasurementIndicator]);


    
    if(userData.length !== 0){

        let Doughnutchartoptions = {maintainAspectRatio: false,
            responsive: true,
            plugins: {
            legend: {
                position: 'right',
            },
            }
        }
       
        
        return (
            <Doughnutchart chartData={userData} chartOptions ={Doughnutchartoptions} excelData = {excelDataChart} ></Doughnutchart>
        );
    }
    else {
        return <></>
    }
}

export default FetchAllAirportsDoughnutChart;
